export type ReportField = 'reviewStatus' | 'userStatus' | 'followUpLabel'

export type InlineUpdateState = {
  status: 'pending' | 'error';
  error?: string;
}

export type InlineUpdates = {
  [reportId: string]: { [K in ReportField]?: InlineUpdateState };
}

export const setInlineUpdate = (
  reportId: string,
  field: ReportField,
  value: InlineUpdateState | null,
  updates: InlineUpdates = {},
): InlineUpdates => {
  if (!reportId) return updates

  const entry = { ...(updates[reportId] || {}) }
  if (value === null) {
    delete entry[field]
  } else {
    entry[field] = value
  }

  if (Object.keys(entry).length === 0) {
    const { [reportId]: _removed, ...rest } = updates
    return rest
  }

  return { ...updates, [reportId]: entry }
}

export type FailureAction = {
  context?: { reportId?: string };
  errors?: Array<{ title?: string; detail?: string }>;
}

export const extractFailureError = (action: FailureAction): string =>
  action.errors?.[0]?.title ?? action.errors?.[0]?.detail ?? 'Update failed'
